import { gql } from '@apollo/client';
import { Schema } from './schema';
import { FileType } from '@jbc-year-end-adj/2024/types';
import { NewOrOldType } from './query';
import { EARTHQUAKE_INSURANCES_FRAGMENT } from './query';

export type QueryVariables = {
  input: {
    earthquakeInsurances: EarthquakeInsurance[];
  };
};

type EarthquakeInsurance = {
  id?: string | undefined;
  image: File | FileType | null;
  amount: string;
  insuranceDuration: string;
  insuranceType: string;
  name: string;
  nameOfContractor: string;
  nameOfRecipient: string;
  newOrOld: NewOrOldType;
};

export const convertFormDataToQueryVariables = (data: Schema): QueryVariables => {
  return {
    input: {
      earthquakeInsurances: data.earthquakeInsurances.map(insurance => {
        return {
          id: insurance.id,
          name: insurance.name,
          insuranceType: insurance.insuranceType,
          insuranceDuration: insurance.insuranceDuration,
          nameOfContractor: insurance.nameOfContractor,
          nameOfRecipient: insurance.nameOfRecipient,
          newOrOld: insurance.newOrOld,
          amount: insurance.amount,
          image: insurance.image
        };
      })
    }
  };
};

export const ANSWER_EARTHQUAKE_INSURANCES = gql`
  mutation AnswerEarthquakeInsurances($input: AnswerEarthquakeInsurancesInput!) {
    answerEarthquakeInsurances(input: $input) {
      questions {
        id
        status
      }
      profile {
        id
        ...EarthquakeInsurances
      }
    }
  }
  ${EARTHQUAKE_INSURANCES_FRAGMENT}
`;
